import { Money } from '@cast/split-me/components';
import { formatCurrency } from '@cast/utils';
import { ReactNode } from 'react';

import { NetworkAreaChart } from './_components/NetworkAreaChart';
import { useNetworkCostChartData } from './_hooks/useNetworkCostChartData';

const getNetworkCostPrecision = (v?: number | null): number => {
  return v && v < 1 ? 6 : 2;
};

const formatCostTick = (value: number) =>
  formatCurrency(value, {
    maximumFractionDigits: getNetworkCostPrecision(value),
  });

const formatCostTooltip = (value: number): ReactNode => {
  const precision = getNetworkCostPrecision(value);
  return <Money amount={value} precision={precision} fixed={precision} />;
};

export const NetworkCostChart = () => {
  const { data, totals, isLoading, isFetching, error, refetch, timeZone } =
    useNetworkCostChartData();
  const isChartLoading = isLoading || (!!error && isFetching);

  return (
    <NetworkAreaChart
      title="Network cost"
      testId="network-cost-chart"
      data={data}
      totals={totals}
      timeZone={timeZone}
      unit=""
      valueType="currency"
      yAxisFormatter={formatCostTick}
      tooltipFormatter={formatCostTooltip}
      isLoading={isChartLoading}
      error={error}
      refetch={refetch}
    />
  );
};
